/* eslint-disable no-console */
import { BASE_DOC_URL, DOC_URL, LOG_LEVEL, version } from '../common/constants';
import { IS_LOCAL, UA_DATA_STRING, getGPUInfo, getUserAgentData, IS_IOS, getOSString } from './environment';
import loggerManager from './log/logger-manager';
// 在测试环境中，__BUILD_TIME__ 可能未定义，提供一个默认值
declare const __BUILD_TIME__: string;
const BUILD_TIME = typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : new Date().toISOString();

let isPrint = true;
export const introInfo = function () {
  if (isPrint) {
    isPrint = false;
    if (loggerManager.getLogLevel() !== LOG_LEVEL.NONE) {
      console.info('******************************************************************************');
      console.info('*   TRTC Web SDK');
      console.info('*   API Document: ' + `${BASE_DOC_URL}/en/index.html`);
      console.info('*   Changelog: ' + `${BASE_DOC_URL}/en/tutorial-01-info-changelog.html`);
      console.info('*   Report issues: ' + 'https://github.com/LiteAVSDK/TRTC_Web/issues');
      console.info('******************************************************************************');
    }
    loggerManager.info('TRTC Web SDK Version:', version);
    if (!IS_LOCAL) {
      loggerManager.debug('Build Time:', BUILD_TIME);
    }
    let UAAndDeviceInfo = `UA: ${navigator.userAgent} \nCPU core: ${navigator.hardwareConcurrency}, GPU: ${getGPUInfo()}`;
    if (IS_IOS && window.screen && (window.screen.width || window.screen.height)) {
      const key = `${window.screen.width}x${window.screen.height}@${window.devicePixelRatio}`;
      UAAndDeviceInfo += `, screen: ${key}`;
    }
    // @ts-ignore
    const minMemory = navigator.deviceMemory;
    if (minMemory) {
      UAAndDeviceInfo += `, minRAM: ${minMemory}GB`;
    }
    loggerManager.info(UAAndDeviceInfo);
    loggerManager.info(`URL: ${location.href}${self.frameElement?.tagName === 'IFRAME' ? ' in iframe' : ''}`);
    getUserAgentData().then(userAgentData => {
      if (userAgentData) {
        loggerManager.info(UA_DATA_STRING);
      }
      loggerManager.info(`OS: ${getOSString()}`);
    });
  }
};
